import { useState, useEffect } from "react";
import api from "../utils/api";
import { SAURABH, GAURI } from "../utils/siteData";

/**
 * Fetches services from the API and enriches them with person info & detail paths.
 *
 * @param {"pooja" | "astrology" | "all"} type – filter by service type
 * @returns {{ services, loading, error, poojaServices, astrologyServices, getServiceDetail }}
 */
export function useServices(type = "all") {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    let url = "/services";
    if (type !== "all") url += `?type=${type}`;

    api
      .get(url)
      .then((res) => {
        const enriched = res.data.map(enrichService);
        setServices(enriched);
      })
      .catch((err) => {
        console.error("Failed to fetch services:", err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, [type]);

  const poojaServices = services.filter((s) => s.type === "pooja");
  const astrologyServices = services.filter((s) => s.type === "astrology");

  const getServiceDetail = (serviceType, slug) => {
    return services.find(
      (s) => s.type === serviceType && s.slug === slug
    );
  };

  return { services, loading, error, poojaServices, astrologyServices, getServiceDetail };
}

/** Fetch a single service by slug (for ServiceDetail page) */
export function useServiceDetail(slug) {
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    api
      .get(`/services/${slug}`)
      .then((res) => setService(enrichService(res.data)))
      .catch((err) => {
        console.error("Failed to fetch service:", err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  return { service, loading, error };
}

/** Fetch service options for dropdowns */
export function useServiceOptions() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/services/options")
      .then((res) => setOptions(res.data))
      .catch(() => setOptions([]))
      .finally(() => setLoading(false));
  }, []);

  return { options, loading };
}

// --- Helper ---

function enrichService(svc) {
  const basePath = svc.type === "pooja" ? "/pooja-services" : "/astrology-palmistry-services";
  const typeLabel = svc.type === "pooja" ? "Pooja Service" : "Astrology Service";
  const person = svc.type === "pooja" ? SAURABH : GAURI;

  return {
    ...svc,
    typeLabel,
    basePath,
    person,
    detailPath: `${basePath}/${svc.slug}`,
  };
}
